<template>
  <div class="select-labels">
    <el-popover
      popper-class="labels-popover"
      placement="bottom-end"
      title="添加话题"
      width="370"
      trigger="click"
      :visible-arrow="false"
      :disabled="selectLabels.length === 2"
      ref="popover">
        <div class="labels-popover-content">
          <el-input class="input-border" v-model="keyword" placeholder="请输入您想搜索的内容">  
          </el-input>
          <ul v-if="keyword" class="search-list">
            <li v-for="label in filterSearchLabels()" :key="label.id" @click="handleChoseLabels(label)">{{label.name}}</li>
          </ul>
          <el-tabs v-else tab-position="left">
            <el-tab-pane v-for="item in labelList" :key="item.id" :label="item.name">
              <div class="label-item flex" v-for="label in item.children" :key="label.id" @click="handleChoseLabels(label)">
                <span class="topic-item-label">#{{label.name}}</span>
                <span>{{label.useCount}}篇内容</span>
              </div>
              <el-button v-if="item.id === -1" class="custom" @click="addCustomLabel"><i class="el-icon-circle-plus" />自定义话题</el-button>
            </el-tab-pane>
          </el-tabs>
        </div>
      <div class="select-labels-content" slot="reference" >
        <span class="topic-item-label" v-for="item in selectLabels" :key="item.id">#{{item.name}}<i class="topic-item-label-cancel" @click="handleCancelLabel(item)">×</i></span>
        <i :class="`el-icon-circle-plus ${selectLabels.length === 2 ? 'disabled' : ''}`" />
      </div>
    </el-popover>
  </div>
</template>

<script>
import { getRecentTopicLabelList, getTopicLabelList } from '@/api/forum';
export default {
  name: 'SelectLabels',
  props: {
    limit: {
      type: Number,
      required: false,
      default: () => 2,
    },
    defaultLabels: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data: () => ({
    // 标签搜索关键字
    keyword: '',
    // 标签列表
    labelList: [],
    // 选中的话题标签
    selectLabels: [],
  }),
  watch: {
    defaultLabels: {
      deep: true,
      handler() {
        this.setSelectLabels();
      },
    }
  },
  created() {
    this.getRecentTopicLabelList();
  },
  methods: {
    // 增加自定义话题
    addCustomLabel() {
      this.$prompt('话题', '输入话题', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        inputPlaceholder: '请输入话题',
        customClass: 'custom-prompt',
        inputPattern: /^[A-Za-z0-9\u4e00-\u9fa5]+$/,
        inputValidator: (value) => {
          if (value.length < 2 || value.length > 12) {
            return '话题长度为2-12个字符';
          }
        },
        inputErrorMessage: '话题不正确'
      }).then(({ value }) => {
        const label = {
          id: 'random-' + Math.random(),
          name: value,
        };
        this.handleChoseLabels(label);
      });
    },
    setSelectLabels() {
      if (this.defaultLabels) {
        let obj = {};
        const filterLabels = this.labelList.map(item => item.children).flat().filter(item => this.defaultLabels.some(label => label.id === item.id));
        this.selectLabels = (this.defaultLabels.length ? (filterLabels || []).concat(...(this.defaultLabels.filter(item => ('' + item.id).startsWith('random-')) || [])) : filterLabels).reduce((cur,next) => {
          obj[next.id] ? "" : obj[next.id] = true && cur.push(next);
          return cur;
        },[])
      }
    },
    // 删除搜索关键字
    handleClearSearch() {
      this.keyword = '';
    },
    // 获取最近使用标签列表
    getRecentTopicLabelList() {
      getRecentTopicLabelList().then(({ data }) => {
        this.labelList = [{
          name: "最近使用",
          parentId: 0,
          id: -1,
          children: data
        }];
        this.getTopicLabelList();
        this.setSelectLabels();
      });
    },
    // 获取所有标签列表
    getTopicLabelList() {
      getTopicLabelList().then(({ data }) => {
        this.labelList.push(...data.filter(item => item.children.length));
        this.setSelectLabels();
      });
    },
    // 点击删除已选择话题标签
    handleCancelLabel(label) {
      this.selectLabels = this.selectLabels.filter(item => item.id !== label.id);
      this.$emit('set-label', this.selectLabels);
    },
    // 点击搜索
    filterSearchLabels() {
      return this.labelList.map(item => item.children).flat().filter(item => item.name.includes(this.keyword));
    },
    // 点击选择标签
    handleChoseLabels(label) {
      if (!this.selectLabels.some(item => item.id === label.id)) {
        if (this.selectLabels.length === this.limit) {
          this.$message.warning(`最多添加${this.limit}个话题`);
          return false;
        }
        
        this.selectLabels = [...this.selectLabels,label]
      }
      this.$emit('set-label', this.selectLabels);
      setTimeout(() => {
        document.body.click();
        this.keyword = '';
      }, 0);
    }
  },
}
</script>
<style lang="scss">
.labels-popover {
  padding: 0!important;
  .el-popover__title {
    padding: 20px;
    border-bottom: 1px solid #EEF0FE;
    @include font(#333, 18px, 600);
  }
}
.custom-prompt {
  /deep/ .el-message-box {
    &__content {
      display: flex;
      align-items: center;
    }
    &__input {
      margin-left: 10px;
      width: 90%;
    }
    &__btns {
      text-align: center;
    }
  }
}
</style>
<style lang="scss" scoped>
@import "../forum.scss";
.labels-popover {
  padding: 0!important;
  &-content {
    padding: 0 20px;
    .search-list, .el-tabs {
      margin: 20px 0;
      border: 1px solid #EEF0FE;
      border-radius: 4px;
    }
    .search-list {
      li {
        padding: 10px;
        cursor: pointer;
        &:hover {
          background-color: rgba(47, 84, 235, 0.05);
          border-radius: 4px;
          color: #2F54EB;
        }
      }
    }
    /deep/ .el-tabs {
      height: 400px;
      overflow: auto;
      &__item {
        font-weight: 400;
        text-align: left!important;
        &.is-active {
          position: relative;
          font-size: 14px;
          color: #333;
          font-weight: 600;
          &::before {
            position: absolute;
            left: 10px;
            top: 50%;
            transform: translateY(-50%);
            display: block;
            content: '';
            border-radius: 50%;
            width: 5px;
            height: 5px;
            background-color: #2F54EB;
          }
        }
      }
      &--left .el-tabs__nav-wrap.is-left::after, .el-tabs__active-bar.is-left {
        display: none;
      }
      &__content {
        height: 100%;
        overflow-y: auto;
      }
    }
  }
  .input-border {
    width: 100% !important;
  }
  .label-item {    
    padding: 0 10px;
    border-radius: 0px 4px 4px 0px;
    align-items: center;
    font-size: 12px;
    cursor: pointer;
    &:hover {
      background-color: rgba(47, 84, 235, .05);
      .topic-item-label {
        background-color: #2F54EB;
        color: #fff;
      }
    }
    
    .topic-item-label.active {
      background-color: #2F54EB;
      color: #fff;
    }
  }
}
.select-labels {
  position: relative;
  &-content {
    padding-left: 10px;
    background-color: #fff;
    border-radius: 4px;
    border: 1px solid #E0E4F7;
    height: 40px;
    &:hover {
      border-color: #C0C4CC;
    }
    .topic-item-label {
      display: inline-block;    
      margin-top: 5px;
      border-radius: 30px;
      line-height: 1.4;
    }
  }
  .el-icon-circle-plus {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
  }
}
.el-icon-circle-plus {
  font-size: 20px;
  color: #ccc;
  &:focus {
    outline: 0;
  }
}
.custom {
  margin: 10px 10px 0  10px;
  width: calc(100% - 20px);
  color: #ccc;
  .el-icon-circle-plus {
    vertical-align: middle;
  }
}
</style>
